module.exports = __webpack_public_path__ + "img/電気回路_6_3_4.fd2fa5b4.png";